<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { Image } from '@sanity/types';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string,
    theme: string,
    anchorId?: string;
    preTitle?: string,
    title?: string,
    text?: string,
    backgroundImage?: Image,
    initialNumber?: number,
    startTime?: string,
    intervalSeconds?: number,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  preTitle: props.block?.preTitle,
  title: props.block?.title,
  text: props.block?.text,
  backgroundImage: props.block?.backgroundImage,
  initialNumber: props.block?.initialNumber,
  startTime: props.block?.startTime,
  intervalSeconds: props.block?.intervalSeconds,
}));
</script>

<template>
  <div class="wrapper wrapper--content" :id="props.block?.anchorId" >
    <component :is="props.config?.innerComponent" v-bind="data" />
  </div>
</template>


